require("!!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/addScript.js")(require("!!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/script-loader/node_modules/raw-loader/index.js!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/site/build/assets/i18n/app/modules/message.fr_FR.js"))


/*****************
 ** WEBPACK FOOTER
 ** ../build/assets/i18n/app/modules/message.fr_FR.js
 ** module id = 13
 ** module chunks = 1 2 4 5
 **/